/* eslint-disable */ import { memoEval, sceneEntityRemoteObjectComponent } from '@salsita-ai/platform-project-sdk/domain';
import { attachComponent } from '../implementation.js';
export const lynxSedonaHoodW48Components = [
    attachComponent.withComponent(sceneEntityRemoteObjectComponent, 'default', true).withEntity('LynxSedonaHoodW48').attach(memoEval(()=>[], ()=>({
            fileUrl: '/models/jms.glb',
            objectName: 'VENT_HOOD_SVH48',
            dimensionUnit: 'inch'
        })))
];

//# sourceMappingURL=lynx-sedona-hood-w-48.js.map